import { SeoHead } from '../components/SeoHead';
import { DemoRequestForm } from '../components/DemoRequestForm';
import styles from './RemodelingWebsites.module.css';

export function FreeDemo() {
  return <div className={styles.page}>
    <SeoHead title="Request a Free Homepage Demo | Verno Web" description="Talk with Nate, then see a free homepage demo for your business. Five-page websites are $995 with basic hosting included; domain costs are separate." path="/free-demo" />
    <section className={styles.requestSection}>
      <div className={styles.wrap + ' ' + styles.requestGrid}>
        <div className={styles.requestCopy}>
          <p className={styles.eyebrow}>YOUR BUSINESS. A FRESH FIRST IMPRESSION.</p>
          <h1 className="display-title">See your new homepage before you commit.</h1>
          <p>Tell me about your business. We’ll have a short call, and if the project fits, I’ll build one free homepage direction for you to review.</p>
          <div className={styles.callNote}><strong>A useful 10-minute conversation.</strong><span>What you do. The work you want to show.<br />Your budget, photos, and timing.</span></div>
          <p>You work directly with me, Nate. No payment for the demo and no obligation to buy the finished website.</p>
          <p>Need a larger site or help with an existing website? Mention it on our call and we’ll agree a separate scope.</p>
        </div>
        <DemoRequestForm />
      </div>
    </section>
  </div>;
}
